module.exports = __webpack_public_path__ + "media/offers/offer-pion-color@2x-fe44f5ca.png";